export class Report
{
    reportId: number;
}
